<!-- 로그인 폼 -->
<template>
    <div class="uk-flex uk-flex-column uk-height-1-1">
        <div class="uk-card uk-card-default uk-card-small uk-width-large uk-align-center uk-margin-auto-vertical">
            <div class="uk-text-center uk-margin-top">
                <app-elem-logo class=""></app-elem-logo>
            </div>
            <div class="uk-card-header">
                <h3 class="uk-card-title uk-margin-small-top">{{ contentTitle }}</h3>
            </div>
            <div class="uk-card-body">
                <form method="post" action="/users/login">
                    <input type="hidden" name="_token" :value="csrf">

                    <fieldset class="uk-fieldset">
                        <app-elem-input
                                :type="'text'"
                                :label="emailLabel"
                                :placeholder="emailPlaceholder"
                                name="email"
                                class="uk-margin"

                                :init-error-msg="emailErrorMsg"
                                :init-val="emailOldValue"
                        ></app-elem-input>

                        <app-elem-input
                                :type="'password'"
                                :label="passwordLabel"
                                :placeholder="passwordPlaceholder"
                                name="password"
                                class="uk-margin"

                                :init-error-msg="passwordErrorMsg"
                        ></app-elem-input>

                        <div uk-grid>
                            <div class="uk-width-auto">
                                <label>
                                    <input class="uk-checkbox" type="checkbox" name="remember" :checked="rememberChecked">
                                    <span class="uk-text-small uk-text-muted">{{ rememberLabel }}</span>
                                </label>
                            </div>
                            <div class="uk-width-expand uk-text-right">

                                <button type="submit" class="uk-button uk-button-primary  uk-float-right">{{ loginButtonName }}</button>
                            </div>
                        </div>

                    </fieldset>
                </form>
            </div>


            <div class="uk-card-footer uk-text-muted">
                아직 고넬로 회원이 아니신가요?
                <a class="uk-link-text uk-text-primary" href="/users/register">가입하기</a>
            </div>

            <div class="uk-card-footer uk-text-muted">
                비밀번호가 기억나지 않으신가요?
                <a class="uk-link-text uk-text-primary" @click="$refs['reset-password'].form()">비밀번호 재설정</a>
            </div>


        </div>


        <!-- 컴포넌트 -->
        <app-user-reset-password ref="reset-password" :csrf-token="csrf"></app-user-reset-password>

    </div>
</template>

<script>
    export default {
        props: {
            loginButtonName: String,
            contentTitle: String,
            emailLabel: String,
            emailPlaceholder: String,
            emailOldValue: String,
            passwordLabel: String,
            passwordPlaceholder: String,
            csrf: String,
            emailErrorMsg: String,
            passwordErrorMsg: String,
            rememberChecked: Boolean,
            rememberLabel: String
        }
    }
</script>
